<template>
  <tr :style="componentStyle">
    <td class="text-center">
      <template v-if="isRanked">{{ requestRank }}</template>
      <template v-else>
        <span
          v-if="isInProgress"
          aria-label="In Progress"
          data-balloon-pos="right"
        >
          <font-awesome-icon
            :icon="$v6.solid.faCompassDrafting"
            fixed-width
            size="lg"
          />
        </span>
        <span
          v-else-if="isReleased"
          aria-label="Released!"
          data-balloon-pos="right"
        >
          <font-awesome-icon
            :icon="$v6.solid.faSparkles"
            fixed-width
            size="lg"
          />
        </span>
      </template>
    </td>
    <td scope="row">
      <span class="display-flex flex-items-center flex-content-between">
        <a
          :href="requestUrl"
          target="_blank"
          style="flex-grow: 1"
        >
          {{ requestTitle }}
        </a>

        <span
          v-if="isInProgress && isRanked"
          aria-label="In Progress"
          data-balloon-pos="up"
          class="margin-left-lg"
        >
          <font-awesome-icon
            :icon="$v6.solid.faCompassDrafting"
            fixed-width
            size="lg"
          />
        </span>
      </span>
    </td>
    <td>
      <font-awesome-icon
        :icon="$v6.regular.faMessage"
        fixed-width
        size="lg"
        class="margin-right-2xs"
        style="color: var(--fa-gravy)"
      />
      {{ requestCommentsTotal }}
    </td>
    <td>
      <font-awesome-icon
        :icon="$v6.regular.faFaceSmile"
        fixed-width
        size="lg"
        class="margin-right-2xs"
        style="color: var(--fa-gravy)"
      />
      {{ requestReactionsTotal }}
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'RequestsRow',

    props: {
      customStyle: {
        type: Object,
        default: () => {}
      },

      isInProgress: {
        type: Boolean,
        default: false
      },

      isRanked: {
        type: Boolean,
        default: false
      },

      isReleased: {
        type: Boolean,
        default: false
      },

      requestCommentsTotal: {
        type: Number,
        default: null
      },

      requestRank: {
        type: Number,
        default: null
      },

      requestTitle: {
        type: String,
        default: null
      },

      requestReactionsTotal: {
        type: Number,
        default: null
      },

      requestUrl: {
        type: String,
        default: null
      }
    },

    computed: {
      componentStyle() {
        return {
          ...this.customStyle
        }
      }
    }
  }
</script>
